import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledAgendaEventTypeButton = styled(Button)<{
    $isSelected: boolean
}>(
    ({theme: {palette}, $isSelected}) => css`
        color: ${palette.neutral['500']};
        outline: 1px solid transparent;
        ${$isSelected &&
        css`
            outline: 1px solid ${palette.neutral['300']};
            color: ${palette.neutral['950']};
        `}
    `
)
